import React from 'react';

interface Props {
  children: React.ReactNode;
}

/**
 * Pass-through. The decoupled CTI web app runs standalone in a browser (AuthGate shows the SSO
 * sign-in) *or* embedded as a Microsoft Teams Tab — the same build, no Teams-only block. Kept as a
 * named gate so the app's gate composition (boot/AppShell) stays unchanged.
 */
export default function TeamsOnlyGate({ children }: Props): React.ReactElement {
  return <>{children}</>;
}
